export default __webpack_public_path__ + "static/media/lock-icon.82ad6539.svg";